import { useMemo } from "react";
import { useDataLayer } from "data-layer";
import { useRoundApprovedApplications } from "../../projects/hooks/useRoundApplications";
import { useRoundStakingSummary } from "../../projects/hooks/useRoundStakingSummary";
import { useSortApplications } from "../../projects/hooks/useSortApplications";
import { ProjectCard } from "./ProjectCard";
import { useSearchParams } from "react-router-dom";
import { useIsStakable } from "../ViewProjectDetails/components/StakingBannerAndModal/hooks/useIsStakable";
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
export const ProjectList = props => {
  const {
    projects: _projects,
    roundRoutePath,
    chainId,
    roundId
  } = props;
  const dataLayer = useDataLayer();
  const [searchParams] = useSearchParams();
  const sortOption = searchParams.get("orderBy");
  const isStakableRound = useIsStakable({
    chainId,
    roundId
  });
  let SortOptionEnum = /*#__PURE__*/function (SortOptionEnum) {
    SortOptionEnum["TOTAL_STAKED_DESC"] = "totalStakedDesc";
    SortOptionEnum["TOTAL_DONATIONS_DESC"] = "totalDonationsDesc";
    SortOptionEnum["TOTAL_CONTRIBUTORS_DESC"] = "totalContributorsDesc";
    SortOptionEnum["TOTAL_STAKED_ASC"] = "totalStakedAsc";
    SortOptionEnum["TOTAL_CONTRIBUTORS_ASC"] = "totalContributorsAsc";
    SortOptionEnum["TOTAL_DONATIONS_ASC"] = "totalDonationsAsc";
    return SortOptionEnum;
  }({});
  const params = isStakableRound ? {} : {
    chainId,
    roundId
  };
  const {
    data: _applications
  } = useRoundApprovedApplications(params, dataLayer);
  const {
    data: poolSummary,
    isLoading
  } = useRoundStakingSummary(roundId, chainId.toString(), isStakableRound);
  const _stakedApplications = useSortApplications(poolSummary, chainId.toString(), roundId, SortOptionEnum[sortOption]);
  const applications = useMemo(() => {
    return _applications !== null && _applications !== void 0 && _applications.length ? _applications : _stakedApplications !== null && _stakedApplications !== void 0 ? _stakedApplications : [];
  }, [_stakedApplications, _applications]);
  const isDonationPeriodStarted = props.showProjectCardFooter;
  const LeaderboardTitle = useMemo(() => {
    return sortOption === "TOTAL_STAKED_DESC" ? "Leaderboard - Most GTC Staked" : sortOption === "TOTAL_DONATIONS_DESC" ? "Leaderboard - Most Donations" : sortOption === "TOTAL_CONTRIBUTORS_DESC" ? "Leaderboard - Most Contributors" : sortOption === "TOTAL_STAKED_ASC" ? "Leaderboard - Least GTC Staked" : sortOption === "TOTAL_CONTRIBUTORS_ASC" ? "Leaderboard - Least Contributors" : sortOption === "TOTAL_DONATIONS_ASC" ? "Leaderboard - Least Donations" : isStakableRound && isDonationPeriodStarted ? "Leaderboard - Most GTC Staked" : "";
  }, [sortOption, isStakableRound, isDonationPeriodStarted]);
  const projects = useMemo(() => {
    var _applications$map;
    return (_applications$map = applications.map(application => {
      return _projects === null || _projects === void 0 ? void 0 : _projects.find(project => {
        var _project$anchorAddres, _application$anchorAd;
        return ((_project$anchorAddres = project.anchorAddress) === null || _project$anchorAddres === void 0 ? void 0 : _project$anchorAddres.toLowerCase()) === ((_application$anchorAd = application.anchorAddress) === null || _application$anchorAd === void 0 ? void 0 : _application$anchorAd.toLowerCase());
      });
    })) !== null && _applications$map !== void 0 ? _applications$map : [];
  }, [applications, _projects]);
  const applicationsMapByGrantApplicationId = useMemo(() => {
    if (!applications) return;
    const map = new Map();
    applications.forEach(application => map.set(application.projectId, application));
    return map;
  }, [applications]);
  return /*#__PURE__*/_jsxs("div", {
    className: "flex flex-col gap-y-8",
    children: [LeaderboardTitle && !props.isProjectsLoading && !isLoading && /*#__PURE__*/_jsx("span", {
      className: "text-[32px]/[39px] font-modern-era-medium",
      children: LeaderboardTitle
    }), /*#__PURE__*/_jsx("div", {
      className: "grid gap-x-6 gap-y-12 gap-5 justify-around md:justify-start sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 w-full",
      children: props.isProjectsLoading || isLoading ? /*#__PURE__*/_jsx(_Fragment, {
        children: Array(6).fill("").map((item, index) => /*#__PURE__*/_jsx("div", {
          className: "relative animate-pulse bg-grey-100 w-[326px] rounded-3xl h-[370px]"
        }, index))
      }) : projects !== null && projects !== void 0 && projects.length ? /*#__PURE__*/_jsx(_Fragment, {
        children: projects.map(project => {
          var _applicationsMapByGra, _applicationsMapByGra2, _project$projectRegis, _applicationsMapByGra3, _applicationsMapByGra4, _project$projectRegis2, _applicationsMapByGra5, _applicationsMapByGra6, _project$projectRegis3;
          return /*#__PURE__*/_jsx(ProjectCard, {
            project: project,
            roundRoutePath: roundRoutePath,
            showProjectCardFooter: props.showProjectCardFooter,
            isBeforeRoundEndDate: props.isBeforeRoundEndDate,
            roundId: props.roundId,
            round: props.round,
            chainId: props.chainId,
            setCurrentProjectAddedToCart: props.setCurrentProjectAddedToCart,
            setShowCartNotification: props.setShowCartNotification,
            crowdfundedUSD: (_applicationsMapByGra = applicationsMapByGrantApplicationId === null || applicationsMapByGrantApplicationId === void 0 || (_applicationsMapByGra2 = applicationsMapByGrantApplicationId.get((_project$projectRegis = project === null || project === void 0 ? void 0 : project.projectRegistryId) !== null && _project$projectRegis !== void 0 ? _project$projectRegis : "")) === null || _applicationsMapByGra2 === void 0 ? void 0 : _applicationsMapByGra2.totalAmountDonatedInUsd) !== null && _applicationsMapByGra !== void 0 ? _applicationsMapByGra : 0,
            uniqueContributorsCount: (_applicationsMapByGra3 = applicationsMapByGrantApplicationId === null || applicationsMapByGrantApplicationId === void 0 || (_applicationsMapByGra4 = applicationsMapByGrantApplicationId.get((_project$projectRegis2 = project === null || project === void 0 ? void 0 : project.projectRegistryId) !== null && _project$projectRegis2 !== void 0 ? _project$projectRegis2 : "")) === null || _applicationsMapByGra4 === void 0 ? void 0 : _applicationsMapByGra4.uniqueDonorsCount) !== null && _applicationsMapByGra3 !== void 0 ? _applicationsMapByGra3 : 0,
            totalStaked: (_applicationsMapByGra5 = applicationsMapByGrantApplicationId === null || applicationsMapByGrantApplicationId === void 0 || (_applicationsMapByGra6 = applicationsMapByGrantApplicationId.get((_project$projectRegis3 = project === null || project === void 0 ? void 0 : project.projectRegistryId) !== null && _project$projectRegis3 !== void 0 ? _project$projectRegis3 : "")) === null || _applicationsMapByGra6 === void 0 ? void 0 : _applicationsMapByGra6.totalStaked) !== null && _applicationsMapByGra5 !== void 0 ? _applicationsMapByGra5 : 0
          }, project === null || project === void 0 ? void 0 : project.projectRegistryId);
        })
      }) : /*#__PURE__*/_jsx("p", {
        children: "No projects"
      })
    })]
  });
};